import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { GeographicEntityForm } from '@/components/geographic/GeographicEntityForm'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { geographicEntities } from '@/config/geographicEntities'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateGeographicRegionPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const config = geographicEntities.geographicRegions

  return (
    <AdminLayout>
      <Box p={4}>
        <Card>
          <CardHeader>
            <Heading size="md">Create {config.singular}</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>Add a new PH region</Text>
          </CardHeader>
          <CardBody>
            <GeographicEntityForm config={config} onSuccess={() => navigate(config.basePath)} onCancel={() => navigate(config.basePath)} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
